import React from "react";
import { Flower2Icon } from "lucide-react";
export function Footer() {
  return <footer className="bg-ink px-5 pb-32 pt-12 text-center" data-id="element-165" data-mp="207t3aclgdrn5">
      <div className="mx-auto max-w-3xl" data-id="element-166" data-mp="207b1l0g0ul7u">
        <div className="flex items-center justify-center gap-2 text-cream" data-id="element-167" data-mp="2f5d4r9j554ok">
          <Flower2Icon className="h-5 w-5" aria-hidden="true" data-id="element-168" data-mp="2f2h43dfws1wf" />
          <span className="font-serif text-lg font-bold" data-id="element-169" data-mp="2a69wzhbs0kcw">Reflexology Session Blueprint™</span>
        </div>
        <p className="mt-3 text-sm text-cream/70" data-id="element-170" data-mp="1mgfnn9qo1dxe">© 2026 · Elly Delgado · All Rights Reserved.</p>
        <p className="mt-5 text-xs leading-relaxed text-cream/60" data-id="element-171" data-mp="1hiw9e9tyx15g">
          Educational and wellness material only. Reflexology Session Blueprint™ does not replace professional education, medical diagnosis, medical treatment, or healthcare advice. Reflexology should not be used as a substitute for professional medical care.
        </p>
      </div>
    </footer>;
}